<div class="w-full bg-white border-box radius-10" style="border-radius: 10px;" id="election-sirets">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center mb-5">
      <img src="assets/square-icon.svg" alt="">
      <div>
        <p class="no-margin light-blue bold">Listes des SIRET des autres établissements concernés</p>
        <p class="no-margin dark-gray text-sm">
          Bloc optionnel - Ajoutez les SIRET des autres établissements concernés par cette élection
        </p>
      </div>
    </div>
  </div>


  <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px;" id="information-grid"
    class="p-20">



    <div *ngFor="let siret of sirets.sirets; let i = index; trackBy: trackByIndex" style=" grid-column: 1 / -1">
      <p class="dark-blue no-margin bold">SIRET</p>
      <div class="flex content-between gap-10 align-items-center">
        <input [(ngModel)]="sirets.sirets[i]" (ngModelChange)="onSiretsChange()" (keypress)="onlyNumbers($event)"
          type="text" name="siret-{{i}}" id="siret-{{i}}" maxlength="14" pattern="[0-9]*" inputmode="numeric"
          class="w-full text-md dark-blue pap-input" value="{{siret}}">
          <img src="assets/trash-red-icon.svg" alt="trash" class="pointer" (click)="deleteAt(i)">
      </div>
    </div>

    <button *ngIf="sirets.sirets.length < 10" class="w-full p-5 bg-white radius-10 dark-blue bold"
      style="border: solid 1px #E2E8F0; grid-column: 1 / -1;" (click)="sirets.sirets.push('')">
      + Ajouter un siret
    </button>

  </div>
</div>